import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'choose_measure',
        component: () => import('../views/ChooseMeasure.vue'),
    },
    {
        path: '/assessment',
        name: 'assessment',
        component: () => import('../views/Assessment.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
